function productFilterModule (FilterApi) {

	__ = null

	this.listen = function () {
		if (!$('.js-product-filters').length) {
			return
		}

		FilterApi.setRoute('/hearing-aids')
		
		$('#order-by').on('changed.bs.select', function (e, clickedIndex, isSelected, previousValue) {
			FilterApi.submit()
		});

		$('#order-by-name').on('changed.bs.select', function (e, clickedIndex, isSelected, previousValue) {
			FilterApi.submit()
		});

		$('#price-filter').on('priceChanged', function () {
			FilterApi.submit()
		});		

		FilterApi.changeListener('.js-product-filter-listener')
	}
}

module.exports = productFilterModule